var _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoOnlyLarge(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    rx: 21.6,
    fill: "url(#paint0_linear_7_54)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.3848 12H31.1129C31.5399 12 31.943 12.198 32.2049 12.5364L38.9034 21.192L38.9079 21.1977L40.3685 23.0417C40.5089 23.219 40.604 23.4282 40.6453 23.6508L41.9766 30.8272C42.0814 31.3921 41.8282 31.9633 41.3399 32.2636L25.8724 41.7766C25.3466 42.1 24.6777 42.0701 24.1827 41.7012C24.1819 41.7006 24.1811 41.7 24.1804 41.6994L17.8769 37.0624L12.3954 30.174L12.1978 29.8445C12.0684 29.6286 12 29.3814 12 29.1295V27.5778C12 27.4299 12.0236 27.283 12.0698 27.1425L12.1788 26.8118L12.2026 26.7658C12.208 26.7554 12.2129 26.7454 12.2207 26.7297C12.2234 26.7241 12.2265 26.7178 12.2301 26.7106C12.2419 26.6867 12.2583 26.6538 12.2773 26.6192C12.3086 26.5622 12.3645 26.4666 12.4515 26.3752L22.0945 15.17C22.2045 15.038 22.3734 14.865 22.6063 14.7466L27.3848 12ZM13.3141 27.4835L13.2928 27.548C13.2897 27.5576 13.2881 27.5677 13.2881 27.5778V29.1295C13.2881 29.1467 13.2928 29.1636 13.3016 29.1783L13.387 29.3208L21.4542 33.7283L36.8287 21.9817L24.9715 19.9602L13.3141 27.4835ZM25.7355 18.7796L36.8755 20.6788L31.1875 13.329C31.1696 13.3059 31.1421 13.2923 31.1129 13.2923H27.9875L25.7355 18.7796ZM26.2447 14.1447L24.3146 18.8475L16.0306 24.1938L23.077 16.0058L23.0808 16.0012C23.1079 15.9685 23.1321 15.9435 23.1531 15.9253C23.1742 15.907 23.1864 15.9004 23.189 15.8991L23.2098 15.8891L26.2447 14.1447ZM38.2875 22.4915L22.3127 34.6968L25.0567 40.7061C25.1053 40.7119 25.1556 40.7016 25.1992 40.6748L40.6668 31.1618C40.7001 31.1413 40.7174 31.1022 40.7103 31.0636L39.379 23.8873C39.3761 23.8721 39.3696 23.8578 39.36 23.8457L38.2875 22.4915ZM22.9477 39.1902L21.0163 34.9606L15.4191 31.9025L18.7766 36.1218L22.9477 39.1902Z",
    fill: "url(#paint1_linear_7_54)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7_54",
    x1: 58.0421,
    y1: -24.8008,
    x2: 11.3369,
    y2: 53.7207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8DEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C61EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7_54",
    x1: -13.8218,
    y1: 71.2255,
    x2: 57.009,
    y2: -0.71852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoOnlyLarge);
export default __webpack_public_path__ + "static/media/logo-only-large.40fae9780497f2dcec31fd77f0a075de.svg";
export { ForwardRef as ReactComponent };